export default {
  GENERATE_STRUCTURE: 'HOT_FOLDER_GENERATE_STRUCTURE',
  LOAD_FILES: 'HOT_FOLDER_LOAD_FILES',
  GET_LOAD_RESULT: 'HOT_FOLDER_GET_LOAD_RESULT',
  LOAD_FILES_SUCCESS: 'HOT_FOLDER_LOAD_FILES_SUCCESS'
}
